import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { ProfileData, ProfileState } from '../../types/Profile';

const initialState: ProfileState = {
  profileData: null,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfileData(state, action: PayloadAction<ProfileData>) {
      state.profileData = action.payload;
    },
    setSkipSurvey(state, action: PayloadAction<ProfileData['skipSurvey']>) {
      state.profileData!.skipSurvey = action.payload;
    },
    resetProfile(state) {
      state.profileData = null;
    },
  },
});

export const { setProfileData, setSkipSurvey, resetProfile } = profileSlice.actions;
export default profileSlice.reducer;
